// The ifttt.ai homepage sets this to the ifttt.com origin, because every other ifttt.ai path
// costs a 302 to ifttt.com. On every other page it is blank, so paths stay relative.
export const linkOrigin = (): string => window.App?.linkOrigin ?? ""
